
















import { Component, Vue, Watch } from "vue-property-decorator";
import { hotSearch, queryPrefix, delHistory, getCueWord } from "@/req/home";
import { logout } from "@/req/user";
@Component({
  components: {},
})
export default class Home extends Vue {
  public activePath = ""; // 当前选中页面路径
  public showPath = false; // 是否显示路径
  public limit = 0;
  public shows = true;
  public navList = [
    {
      name: "推荐",
      path: "/home/index",
    },
    {
      name: "新服",
      path: "/home/newServer",
    },
    {
      name: "发现",
      path: "/home/discover",
    },
    {
      name: "排行",
      path: "/home/list",
    },
    {
      name: "期待",
      path: "/home/forward",
    },
    // {
    //   name: "交易行",
    //   path: "/home/transaction",
    // },
  ];
  public mounted() {
    this.$fn.userRecord(1700, 1);
    // 防止页面刷新，导航栏失去焦点
    for (let i = 0; i < this.navList.length; i++) {
      if (this.navList[i].path == this.$route.path) {
        this.limit = i;
        this.shows = true;
      }
    }
  }
  public toPath(paths, index) {
    if (paths == "/home/index") {
      this.$fn.userRecord(1700, 2);
    }
    if (paths == "/home/newServer") {
      this.$fn.userRecord(1800, 2);
    }
    if (paths == "/home/discover") {
      this.$fn.userRecord(1900, 2);
    }
    if (paths == "/home/list") {
      this.$fn.userRecord(2000, 2);
    }
    this.limit = index;
    this.$router.push({ path: paths });
  }
  @Watch("$route")
  public change(item) {
    if (item.path == "/" || item.path == "/home/index") {
      this.$fn.userRecord(1700, 1);
      this.limit = 0;
      this.shows = true;
      return false;
    }
    if (item.path == "/home/newServer") {
      this.$fn.userRecord(1800, 1);
      this.limit = 1;
      this.shows = true;
      return false;
    }
    if (item.path == "/home/discover") {
      this.$fn.userRecord(1900, 1);
      this.limit = 2;
      this.shows = true;
      return false;
    }
    if (item.path == "/home/list") {
      this.$fn.userRecord(2000, 1);
      this.limit = 3;
      this.shows = true;
      return false;
    }
    // if (item.path == "/home/transaction") {
    //   //   this.$fn.userRecord(2000, 1);
    //   this.limit = 4;
    //   this.shows = true;
    //   return false;
    // }
    if (item.path == "/home/forward") {
      //   this.$fn.userRecord(2000, 1);
      this.limit = 4;
      this.shows = true;
      return false;
    }
    if (item.path == "/search") {
      //   this.$fn.userRecord(2000, 1);
      this.shows = true;
      return false;
    }
    this.limit = -1;
    this.shows = false;
  }
}
